import React from 'react';
import { Calendar as ReactDateRangeCalendar } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file

export interface Props {
  date: Date | undefined;
  onChange?: (date: Date) => void;
  minDate?: Date;
  maxDate?: Date;
}

export const Calendar = ({ date, onChange, minDate, maxDate }: Props) => {
  const containerRef: any = React.createRef();
  const handleSelect = (selectEventValue: Date) => {
    onChange && onChange(selectEventValue);
  };

  return (
    <div ref={containerRef}>
      <ReactDateRangeCalendar
        date={date}
        onChange={handleSelect}
        minDate={minDate}
        maxDate={maxDate}
      />
    </div>
  );
};
